import { useState, useEffect } from 'react';
import './../../../core/style/GlobalNav.css';
import WHATSAPP_NUMBER from "./../../../core/constants/constants";
import Toast from '../../Components/toaster/Toast'; 

const GlobalNav = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const [toastConfig, setToastConfig] = useState({ show: false, type: 'success', title: '', message: '' });

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleDownloadBrochure = async (e) => {
    e.preventDefault();
    setIsMenuOpen(false);

    const fileUrl = '/docs/busan_brochure.pdf';
    const fileName = 'Busan_Hydraulic_Breaker_Brochure.pdf';

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) throw new Error('File not found');

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      // Call the Success configuration
      setToastConfig({
        show: true,
        type: 'success',
        title: 'Download Complete',
        message: 'Busan industrial product brochure successfully saved.'
      });

    } catch (error) {
      // Call the Error configuration
      setToastConfig({
        show: true,
        type: 'error',
        title: 'Download Interrupted',
        message: 'Failed to access the file. Please contact support via WhatsApp.'
      });
    }
  };

  const handleGeneralInquiry = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const message = `Hello Busan Hydraulic Breaker,

I am visiting your website and I would like to request a quote. 
I am interested in learning more about your:
- Product Range
- Pricing & Quotation
- Delivery Procedure & Timelines

Could you please guide me on the next steps?`;

    const encodedMessage = encodeURIComponent(message);
    const targetNumber = String(WHATSAPP_NUMBER).replace(/\D/g, '');
    const whatsappUrl = `https://wa.me/${targetNumber}?text=${encodedMessage}`;

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    setIsMenuOpen(false); 
  };

  return (
    <>
      {/* Plug-and-Play Common Component Implementation */}
      <Toast 
        show={toastConfig.show} 
        type={toastConfig.type} 
        title={toastConfig.title} 
        message={toastConfig.message} 
        onClose={() => setToastConfig(prev => ({ ...prev, show: false }))} 
      />

      <nav className={`nav-bar ${isScrolled ? 'nav-scrolled' : ''} ${isMenuOpen ? 'nav-open' : ''}`}>
        <div className="nav-container">
          <div className="nav-logo">
            <img src='/images/BusanLogo1.png' alt='Hydraulic Breaker' style={{height: '50px', width: '110px'}} />
          </div>

          <div className={`burger-menu ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
          </div>

          <ul className={`nav-links ${isMenuOpen ? 'mobile-active' : ''}`}>
            <li className="btn-ghost"><a href="#catalog" onClick={() => setIsMenuOpen(false)}>Products</a></li>
            <li className="btn-ghost"><a href="#specs" onClick={() => setIsMenuOpen(false)}>Technical Details</a></li>
            <li className="btn-ghost"><a href="#guidance" onClick={() => setIsMenuOpen(false)}>Guidance</a></li>
            
            <li className="mobile-only-cta">
              <button className="btn-brochure alerting-pulse" onClick={handleDownloadBrochure}>
                Brochure
              </button>
            </li>
            <li className="mobile-only-cta">
              <button className="btn-white" onClick={handleGeneralInquiry}>Request Quote</button>
            </li>
          </ul>

          <div className="nav-cta">
            <div className="nav-actions">
              <button className="btn-brochure alerting-pulse" onClick={handleDownloadBrochure}>
                Download Brochure
              </button>
              <button className="btn-white" onClick={handleGeneralInquiry}>Request Quote</button>
            </div>
          </div>
        </div>
        <div className={`nav-overlay ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}></div>
      </nav>
    </>
  );
};

export default GlobalNav;